import { iconSpec } from './history-entry-icon-spec';
import type { HistoryEntryView } from './private-event-history-rows';

export default function HistoryEntryIcon({ entry }: { entry: HistoryEntryView }) {
  const { Icon, bg, fg, label } = iconSpec(entry);
  return (
    <span
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      style={{
        width: 22,
        height: 22,
        borderRadius: 6,
        flexShrink: 0,
        marginTop: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: bg,
        color: fg,
      }}
    >
      <Icon size={12} aria-hidden />
    </span>
  );
}
